import { Component, OnInit, OnDestroy }   from '@angular/core';
import { ActivatedRoute }                 from '@angular/router';
import { UserService }                    from '../../_services/user.service'; 
import { Router }                         from '@angular/router';
import { AuthService }                    from '../../auth/ind/auth.service';
import { Credentials, Scope, Ops, User }  from '../../_models/index';
import { EqualValidator }                 from '../../_directives/index';
import { catchError, first } from 'rxjs/operators';
import { Subscription, throwError } from 'rxjs';
//import { NgFlashService } from 'ng-flash';

declare var $: any;
@Component({
  selector: 'ind-start-process',
  templateUrl: './start-process.component.html',
  styleUrls: ['./start-process.component.css']
})
export class StartProcessComponent implements OnInit, OnDestroy {
  parm: any;
  model: any;  
  credentials: Credentials;
  link: string;
  id_token: string;
  private sub: any;
  public hideSubmit: boolean = false;
  loading:boolean = false;
  success:boolean = false;
  user: User;
  acceptAgree: boolean = false;;
  viewedAgreement: boolean = false;;  
  subscription: Subscription | null = null;
  constructor(private route: ActivatedRoute,
          private userService: UserService,
          private router: Router, 
          private auth: AuthService) { }
          //private _ngFlashService: NgFlashService

  ngOnInit() {
    //this.IMG_ANI_REFRESH = IMG_ANI_REFRESH;
    this.loading = false;
    this.success = false;
    this.hideSubmit = false;
    this.sub = this.route.params.subscribe(params => {
      //alert('Param s:'+params['s']) ;
      this.parm = params['s'];
    });
    var urlqry = decodeURIComponent(this.parm);
    var result: Record<string, any> = {};
    urlqry.split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    /*var data2 = "refid="+this.refid+"&id="+this.referralid+"&fid="+this.formId+"&email="+ this.entity.email;
    var data1 = "f="+ post.entity.firstname+"&l"+ post.entity.lastname+"=&e="+this.entity.email+"&c="+mcryptlink(data2,"","");
    var link = REFER_IND_START_URL + "s="+encodeURIComponent(data1);//+mcryptlink(data2,"","");*/
    //alert('DecodedURI RESULT: '+JSON.stringify(result));
    //alert('DecodedURI f: '+result['f']);
    var tmpObj = {"firstname":"", "lastname":"", "email":""};
    tmpObj.firstname = result['f'];
    tmpObj.lastname = result['l'];
    tmpObj.email = result['e']?.toLowerCase().trim();    
    this.model = tmpObj;  
    this.credentials = { email: result['e']?.toLowerCase().trim(), scope: Scope.BF_ENT, password: ""};    
    //this.credentials['email'] = result['e'];
    this.link = result['c'];
    this.acceptAgree = false;
    this.viewedAgreement = false;

    //alert('Params RESULT: '+JSON.stringify(model) + ":" + JSON.stringify(this.credentials) + ":" + JSON.stringify(this.link));

  }

  ngOnDestroy() {
    try{
      this.sub.unsubscribe();
      this.subscription?.unsubscribe();  
    }catch(e){

    }
  }

  acceptAgreement(){
    this.viewedAgreement = true;        
    this.acceptAgree =  true;
    $("#myModal").modal("hide");
  }

  startProcess(){
    this.loading = true;    //alert('Credentials: '+JSON.stringify(this.credentials));
    this.hideSubmit = true;
    this.userService.startOpsProcess(this.credentials)
      .subscribe(
          response => {
                //console.log('startOpsProcess response:' + JSON.stringify(response));
                this.userService.startProcess(this.link, this.credentials)
                .subscribe(
                data => {//alert('Start Process done. Calling auth.login with: '+JSON.stringify(this.credentials));
                  this.success = true;
                  //console.log('Start process successful.'+JSON.stringify(this.credentials));
                  this.subscription=this.auth.login(this.credentials)
                    .subscribe(
                    result => {
                        if (result.success){
                            this.user = this.auth.currentUserValue;    
                            this.router.navigate(["/ind/ind-home"]);
                        }else{
                          console.log('Start process fail:'+result.message);
                          this.loading = false;                    
                          this.router.navigate(["/ind-login"]);            
                          //this.router.navigateByUrl("ind-login");
                        }
                    },
                    err => {
                      switch (err.statusCode){
                          case 412:
                            //alert('User is not activated. Please check your email for activation email or click on Reset Your Password');
                            break;
                          default:
                            //alert('Invalid login. Please check the entered Email, Password and Sign In Type. ');
                      }
                          this.loading = false;    
                          this.router.navigate(["/ind-login"]);
                          //this.router.navigateByUrl("ind-login");
                        }
                  );
                },
                error => {
                  //alert('Starting Referral Process failed.'+JSON.stringify(error));
                  console.log('Starting referral process failed: '+JSON.stringify(error))
                  //this._ngFlashService.danger('Starting Referral Process failed.');        
                  this.loading = false;    
                  this.router.navigate(["/ind-login"]);
                    //this.alertService.error(error);
                }
              );

          },
          err => {
            switch (err.statusCode){
                case 412:
                  console.log('Error in startOpsProcess 412'+err.message)
                  //alert('User is not activated. Please check your email for activation email or click on Reset Your Password');
                  break;
                default:
                  console.log('Error in startOpsProcess'+err.message)
                  //alert('Invalid login. Please check the entered Email, Password and Sign In Type. ');
            }
            this.loading = false;    
            this.router.navigate(["/ind-login"]);
            //this.router.navigateByUrl("ind-login");
          }
      )
        this.hideSubmit = false;
  };
}
